import React from 'react';
import { connect } from 'react-redux';

import { Panel, PanelTop } from 'components/Panel';
import { Table, Td } from 'components/Table';
import PlayerLink from 'components/PlayerLink';
import ResultLink from 'components/ResultLink';

const HighlightsX = ({ highlights }) => (
    <Panel border>
        <PanelTop>
            <h2>Highlights</h2>
        </PanelTop>
        <div>
            <Table compact>
                <tbody>{highlights.map((highlight, index) => <HighlightsRow key={index} highlight={highlight} />)}</tbody>
            </Table>
        </div>
    </Panel>
);

const Highlights = connect(state => ({
    highlights: state.data.highlights
}))(HighlightsX);

export default Highlights;

const HighlightsRow = ({ highlight }) => {
    let opposition = highlight.opposition;
    if (highlight.url) {
        opposition = (
            <a href={highlight.url} target="_new">
                {opposition}
            </a>
        );
    }
    switch (highlight.type) {
        case 'section':
            return (
                <tr className="cc-row-section">
                    <Td colspan="3" left>
                        {highlight.title}
                    </Td>
                </tr>
            );
        case 'milestone':
            return (
                <tr>
                    <Td left>
                        <PlayerLink pid={highlight.pid} fname={highlight.fname} lname={highlight.lname} rolloverDirection="left" />
                    </Td>
                    <Td colspan="2" left>
                        {highlight.milestone}
                    </Td>
                </tr>
            );
        case 'batting':
            return (
                <tr>
                    <Td left>
                        <PlayerLink
                            pid={highlight.pid}
                            fname={highlight.fname}
                            lname={highlight.lname}
                            runs={highlight.runs}
                            rolloverDirection="left"
                        />
                    </Td>
                    <Td left>
                        <ResultLink fixture={highlight}>{highlight.runs + (highlight.isout === 'NOT OUT' ? '* runs' : ' runs')}</ResultLink>
                    </Td>
                    <Td left>v {opposition}</Td>
                </tr>
            );
        case 'bowling':
            return (
                <tr>
                    <Td left>
                        <PlayerLink
                            pid={highlight.pid}
                            fname={highlight.fname}
                            lname={highlight.lname}
                            wickets={highlight.wickets}
                            rolloverDirection="left"
                        />
                    </Td>
                    <Td left>
                        <ResultLink fixture={highlight}>{`${highlight.wickets} for ${highlight.runs}`}</ResultLink>
                    </Td>
                    <Td left>v {opposition}</Td>
                </tr>
            );
        case 'fielding':
            let catches;
            let stumpings;
            let runouts;
            if (highlight.catches) {
                catches = <p>{`${highlight.catches} catch${highlight.catches === 1 ? '' : 'es'}`}</p>;
            }
            if (highlight.stumpings) {
                stumpings = <p>{`${highlight.stumpings} stumping${highlight.stumpings === 1 ? '' : 's'}`}</p>;
            }
            if (highlight.runouts) {
                runouts = <p>{`${highlight.runouts} runout${highlight.runouts === 1 ? '' : 's'}`}</p>;
            }
            return (
                <tr>
                    <Td left>
                        <PlayerLink
                            pid={highlight.pid}
                            fname={highlight.fname}
                            lname={highlight.lname}
                            victims={highlight.victims}
                            rolloverDirection="left"
                        />
                    </Td>
                    <Td left>
                        <ResultLink fixture={highlight}>
                            {catches}
                            {stumpings}
                            {runouts}
                        </ResultLink>
                    </Td>
                    <Td left>v {opposition}</Td>
                </tr>
            );
    }
};



// WEBPACK FOOTER //
// ./src/views/home/Highlights.jsx